/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'MailAdd': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M21.7 14.7c-.56 0-1.015.454-1.015 1.014v3.272h-3.27a1.014 1.014 0 100 2.028h3.27v3.272a1.014 1.014 0 002.029 0v-3.272h3.272a1.014 1.014 0 100-2.028h-3.272v-3.272c0-.56-.454-1.014-1.014-1.014z" _fill="#2D75F5"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M4.7 4c-1.652 0-3 1.348-3 3v12c0 1.652 1.348 3 3 3h9.8a1 1 0 100-2H4.7c-.548 0-1-.452-1-1V8.92l8.427 5.9a1 1 0 001.146 0l8.427-5.9v4.38a1 1 0 102 0V7.018v-.042A3.006 3.006 0 0020.7 4h-16zm16.893 2.554A1.006 1.006 0 0020.7 6h-16c-.388 0-.728.227-.893.554l8.893 6.225 8.893-6.225z" _fill="#2D75F5"/>'
  }
})
